import { render } from "./SummaryDashboard.vue?vue&type=template&id=0b510bae"
import script from "./SummaryDashboard.vue?vue&type=script&lang=js"
export * from "./SummaryDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Chiche/Projects/mekiotech/authorizer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__